<mat-icon svgIcon="main:{{icon}}" [color]="color"  [ngClass]="{'mat-icon-12': size==='12px', 'mat-icon-16': size==='16px', 'mat-icon-24': size==='24px', 'mat-icon-32': size==='32px'}" ></mat-icon>

